<template>
  <div id="container">
    <header-bar></header-bar>
    <div id="main">
      <slider-picture></slider-picture>
      <service-content></service-content>
      <core-content></core-content>
      <cases-content></cases-content>
      <honor-content></honor-content>
    </div>
    <footer-bar></footer-bar>
    <scroll-back></scroll-back>
  </div>
</template>

<script>
import HeaderBar from "@/components/HeaderBar"
import FooterBar from "@/components/FooterBar"
import SliderPicture from "./components/SlidePicture"
import ServiceContent from "./components/ServiceContent"
import CoreContent from "./components/CoreContent"
import CasesContent from "./components/CasesContent"
import HonorContent from "./components/HonorContent"
export default {
  metaInfo: {
    title: "温州星原统计服务有限公司",
    meta: [
      {
        name: "keywords",
        content: "温州，星原，统计服务，统计代理，文化创意"
      },
      {
        name: "author",
        content: "温州星原统计服务有限公司"
      },
      {
        name: "description",
        content:
          "近几年，随着统计数据逐步走进公众视野，统计工作地位不断提升，但由于基层统计基础薄弱，统计服务对象购买社会统计服务成为重要趋势，统计服务公司作为新兴业态已得到各级领导高度支持和认可。"
      }
    ]
  },
  name: "Home",
  components: {
    HeaderBar,
    FooterBar,
    SliderPicture,
    ServiceContent,
    CoreContent,
    CasesContent,
    HonorContent
  }
};
</script>

<style lang="less" scoped>
#container {
  min-width: 1200px;
}
</style>
